/*
 * @Author: chengweijia-tel:18702108979
 * @Version: 1.0
 * @Date: 2022-02-09 09:11:09
 * @LastEditTime: 2023-03-06 10:16:30
 */
/**
 * 全局变量、系统配置。注册到vue里
 */
// 首页配置
const homeEnum = [
  // {
  //   key: 'company',
  //   value: '中通生态',
  //   name: 'IZHONG TONG ECOLOGYT'
  // },
  {
    key: 'position',
    value: '搜索你的职位',
    name: 'YOUR POSITION'
  },
  {
    key: 'life',
    value: '中通生活',
    name: 'ZHONG TONG LIFE'
  },
  {
    key: 'story',
    value: '员工故事',
    name: 'ZHONG TONG STORY'
  }
]

// 中通生态
const companyEnum = [
  {
    key: '中通快递',
    searchValue: '中通快递',
    value:
      '中通快递创建于2002年5月8日，是一家以快递为核心业务，集跨境、快运、商业、云仓、航空、金融、智能、传媒、冷链、兔喜等生态版块于一体的综合物流服务企业。2016年10月27日在美国纽约证券交易所上市，向全世界打开了一扇了解中国快递发展的窗口；2020年9月29日在香港实现二次上市，成为首家同时在美国、中国香港两地上市的快递企业。'
  },
  {
    key: '中通快运',
    searchValue: '中通快运',
    value:
      '中通快运成立于2016年，聚焦数智物流新趋势， 提供面向企业及个人客户的全链路一站式物流服务。通过布局全国的仓储物流枢纽和末端加盟网络， 围绕物联网、大数据、云计算、人工智能，积极探寻物流业与制造业、服务业融合发展的模式，为客户打造一体化物流解决方案， 致力于打造“科技引领、数据支撑、人才保证、智慧运营”的综合型物流服务平台。'
  },
  {
    key: '中通冷链',
    searchValue: '中通冷链',
    value:
      '中通冷链以直营+加盟为组织模式，依托中通快递集团的网络优势和生态优势，秉持同建共享、信任责任、追求卓越的核心价值观，为市场提供更低成本、更高效能、更好时效的TO B &TO C综合服务，打造中国最大的仓干配一体化物流网络-“中通蓝网”。'
  },
  {
    key: '中通国际',
    searchValue: '中通国际',
    value:
      '作为中通快递集团的国际视窗，自2014年成立以来，中通国际依托其强大的地面服务网络与全球资源整合能力，打造以快递物流为核心，整合海外仓、海外专线与跨境电商供应链的综合业务体系，积极响应国家“一带一路”号召，全面实施“走出去”发展战略，大力拓展国际综合物流，深耕海外市场。'
  },
  {
    key: '中通星联',
    searchValue: '中通星联',
    value:
      '浙江星联航空货运有限公司（简称星联航空），成立于2018年3月，注册资金1.6亿元，是中通快递旗下专业从事航空货运服务的全网链平台公司。通过聚集和依托在全国各省最优质航空货运代理公司的资源，以先进、高效的信息化管理，提供性价比高、品质稳定、时效强的一站式航空货运服务。'
  },
  {
    key: '中通金融',
    searchValue: '中通金融',
    value:
      '中通金融致力于通过金融服务赋能网点，保障中通快递网络健康运营、稳步发展，是中通快递网点特有的融资支撑平台，目前已有融资租赁、商业保理、供应链小贷等牌照。'
  },
  {
    key: '中通云仓',
    searchValue: '中通云仓',
    value:
      '中通云仓科技有限公司，是一家专业为电商、社交电商、新零售、美妆、3C、鞋服、快消…等领域企业提供仓储配送一体化供应链服务的平台。以信息技术驱动智慧供应链，致力于为合作客户提升供应链效率，降低物流成本，保障消费者体验。'
  },
  {
    key: '中通商业',
    searchValue: '中通商业',
    value:
      '中通商业是一家集“商品供应能力+系统工具+运营服务+流量转化”为一体的商业SAAS平台，提供“从田头到餐桌，工厂到用户“全链路商业服务。依托中通快递遍布全国的网络资源，精选各类农副产品、休闲食品、生活用品等，为广大消费者提供高品质、高性价比商品。'
  },
  {
    key: '中通兔喜',
    searchValue: '兔喜',
    value:
      '兔喜以快递自提需求为切入点，通过社会化协同的方式，以高频刚需的到店流量赋能社区小店，构建一张具备标准化形象和多元化服务能力的社区门店网络。通过数据驱动和技术创新，提升快递交付体验的同时，以家庭需求为导向，致力于成为离消费者最近的社区新零售基础设施。建设广泛认可的社区服务品牌，打造有温度的末端社区综合体。兔喜生活+，服务千万家。'
  },
  {
    key: '中快传媒',
    searchValue: '中快传媒',
    value:
      '上海中快文化传媒有限公司是是一家集广告导购、社群、MCN、内容营销等业务于一体的综合性传媒服务公司。依托电商大发展和中通快递的强大网络，通过快递业务的新零售、社交化场景，将中通快递每年服务的数百亿用户人次进行挖掘和沉淀，运用专业化、智能化的技术和线上线下相结合的形式，实现用户流量的广告变现。'
  },
  {
    key: '中通智能',
    searchValue: '中通智能',
    value:
      '中通快递物流智能装备制造项目—“芜湖市双彩智能科技有限公司”是中通集团旗下全资子公司，主要生产快递物流分拣设备、配套装备及面向快递物流行业的其他智能设备。'
  }
]

// 职位类别
const posTypeEnum = [
  {
    key: 'Software',
    value: '软件工程师',
    positionType: 'it-02'
  },
  {
    key: 'Product',
    value: '产品经理',
    positionType: 'it-04'
  },
  {
    key: 'Test',
    value: '质量工程师',
    positionType: 'it-06'
  },
  {
    key: 'Designer',
    value: '设计师',
    positionType: 'it-09'
  },
  {
    key: 'Operation',
    value: '运营网管类',
    positionType: '22'
  },
  {
    key: 'Marketing',
    value: '市场营销类',
    positionType: '29'
  },
  {
    key: 'Service',
    value: '服务质量类',
    positionType: '23'
  }
]

// 隐藏搜索框
const showSearchComponents = ['PositionDetail']

// 社招校招
const resumeTypeEnum = {
  socialEnum: [
    {
      key: 'educationExperiences',
      value: '教育经历',
      image: require('@/assets/h5/icon-educationExperiences.png'),
      name: 'schoolName',
      isComplate: false
    },
    {
      key: 'workExperiences',
      value: '工作经历',
      image: require('@/assets/h5/icon-workExperiences.png'),
      name: 'companyName',
      isComplate: false
    },
    {
      key: 'projectExperiences',
      value: '项目经验',
      image: require('@/assets/h5/icon-workExperiences.png'),
      name: 'projectName',
      isComplate: true
    }
  ],
  campusEnum: [
    {
      key: 'educationExperiences',
      value: '教育经历',
      image: require('@/assets/h5/icon-educationExperiences.png'),
      name: 'schoolName',
      isComplate: false
    },
    {
      key: 'practiceExperienceVoList',
      value: '实习经历',
      image: require('@/assets/h5/icon-workExperiences.png'),
      name: 'practiceCompanyName',
      isComplate: true
    },
    {
      key: 'projectExperiences',
      value: '项目经验',
      image: require('@/assets/h5/icon-workExperiences.png'),
      name: 'projectName',
      isComplate: true
    },
    {
      key: 'schoolOfficeVoList',
      value: '在校职务',
      image: require('@/assets/h5/icon-educationExperiences.png'),
      name: 'cadreName',
      isComplate: true
    }
  ],
  othersEnum: [
    {
      key: 'personalWorksList',
      value: '作品',
      name: 'worksUrl'
    },
    {
      key: 'awardsWonsVoList',
      value: '获奖经历',
      name: 'awardName'
    },
    {
      key: 'languageAbilityVoList',
      value: '语言',
      name: 'languageTypeValue'
    }
  ]
}

const recruiteTypeEnum = {
  social: 1,
  campus: 2,
  CampusPosition: 2,
  blue: 3
}

const recruiteType2String = {
  1: '社会招聘',
  2: '校园招聘',
  3: '一线招聘'
}

export default {
  homeEnum,
  companyEnum,
  posTypeEnum,
  showSearchComponents,
  resumeTypeEnum,
  recruiteTypeEnum,
  recruiteType2String
}
